<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">
        
        <section 
            v-if="isAdmin()"
            slot="above-content" 
            class="gz-action-section_default"
        >
            <GZ-BaseButton
                value="добавить сотрудника"
                class="gz-button gz-button_default" 
                icon="icon-hipster"
                @click="addStaffMember"
            />
        </section>

        <section slot="filters" style="max-width: 300px">
            <gz-select-container
                type="filter"
                class="gz-filter__item gz-checkup__status-select"
                :dataList="staffTypesComputed"
                @selectedItem="staffTypes = $event"
            >
                <GZ-TextInput
                    :importedData="staffTypes.name ? staffTypes.name : ''"
                    :readonly="true"
                    :selectType="true"
                    placeholder="Фильтр по типу"
                />
            </gz-select-container>
        </section>

        <section slot="content">
            <StaffRow 
                v-for="(item, index) in data"
                :key="index"
                :data="item"
            />
        </section>        
    </gz-auth-view-template>
</template>

<script>
import { mapGetters } from 'vuex'
import AddStaff from '@/components/custom/admin/views/staff/AddStaff'
import StaffRow from '@/components/custom/admin/views/staff/BaseStaffRow'

export default {
    name: 'StaffList',
    
    components: {
        StaffRow
    },
    data() {
        return {
            staffTypes: {}
        }
    },
    computed: {
        ...mapGetters({
            staffUsers: 'staffUsers',
        }),
        data() {
            return this.staffUsers
        },
        isAdded() {
            return this.$store.getters['staffIsAdded']
        },
        staffTypesComputed() {
            return this.$store.getters['filterStaffTypes']
        }
    },
    mounted() {
        this.$store.dispatch('staffUsersGet', this.staffTypes.value)
    },
    methods: {
        addStaffMember() {
            this.$store.dispatch('modalOpen', {
                component: AddStaff 
            })
        }
    },
    watch: {  
        isAdded: function(val) {
            this.$store.dispatch('staffUsersGet')
        },
        staffTypes: function() {
            this.$store.dispatch('staffUsersGet', this.staffTypes.value)
        }
    }
}
</script>